import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

export default function Gallery() {
  const { t } = useTranslation();
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const projects = [
    {
      id: 1,
      title: 'Soldadura de Precisión',
      type: 'Proyecto Industrial',
      image: 'https://static.readdy.ai/image/d57f52ecca312558916e136936375c65/c15c50af5f0211a8350080f783cab23c.jpeg'
    },
    {
      id: 2,
      title: 'Escaleras Metálicas',
      type: 'Construcción',
      image: 'https://public.readdy.ai/ai/img_res/6e2b91ea07b73feba8a24a5174a2a90e.jpg'
    },
    {
      id: 3,
      title: 'Fabricación Balcones',
      type: 'Diseño Custom',
      image: 'https://readdy.ai/api/search-image?query=Custom%20designed%20metal%20balcony%20with%20ornamental%20railings%2C%20elegant%20wrought%20iron%20balcony%20fabrication%2C%20professional%20metalwork%20with%20decorative%20patterns%2C%20modern%20residential%20building%20exterior%2C%20high%20quality%20metal%20craftsmanship%20with%20clean%20background&width=800&height=900&seq=gallery003&orientation=portrait'
    },
    {
      id: 4,
      title: 'Portones',
      type: 'Mantenimiento',
      image: 'https://readdy.ai/api/search-image?query=Large%20industrial%20metal%20gate%20with%20modern%20design%2C%20custom%20fabricated%20steel%20entrance%20gate%2C%20professional%20metalwork%20with%20security%20features%2C%20commercial%20property%20entrance%2C%20durable%20metal%20construction%20with%20clean%20simple%20background&width=800&height=900&seq=gallery004&orientation=portrait'
    },
    {
      id: 5,
      title: 'Puertas y Rejas',
      type: 'Seguridad',
      image: 'https://readdy.ai/api/search-image?query=Security%20metal%20door%20and%20window%20grilles%2C%20custom%20fabricated%20steel%20security%20bars%2C%20professional%20metalwork%20for%20residential%20protection%2C%20modern%20security%20design%20with%20decorative%20elements%2C%20clean%20background%20highlighting%20metal%20craftsmanship&width=800&height=900&seq=gallery005&orientation=portrait'
    },
    {
      id: 6,
      title: 'Planos De Estructuras Metálicas',
      type: 'Diseño Interior',
      image: 'https://static.readdy.ai/image/d57f52ecca312558916e136936375c65/0452bb1937f3ee913860b973a16c75f1.png'
    },
    {
      id: 7,
      title: 'Barandas Industriales',
      type: 'Seguridad Industrial',
      image: 'https://readdy.ai/api/search-image?query=Industrial%20metal%20railings%20and%20handrails%20installation%2C%20commercial%20grade%20steel%20safety%20barriers%2C%20professional%20metalwork%20for%20industrial%20facilities%2C%20modern%20safety%20railing%20system%2C%20clean%20industrial%20background%20highlighting%20metal%20construction&width=800&height=900&seq=gallery007&orientation=portrait'
    },
    {
      id: 8,
      title: 'Decks Estructuras de Acero',
      type: 'Construcción Comercial',
      image: 'https://static.readdy.ai/image/d57f52ecca312558916e136936375c65/7375c08f657e5569184b4add2426f40b.jpeg'
    },
    {
      id: 9,
      title: 'Decks',
      type: 'Diseño Custom',
      image: 'https://static.readdy.ai/image/d57f52ecca312558916e136936375c65/56aaa22fce4b41984791b41c3d3d7e1e.jpeg'
    },
    {
      id: 10,
      title: 'Techos Metálicos',
      type: 'Construcción',
      image: 'https://readdy.ai/api/search-image?query=Metal%20roofing%20structure%20installation%2C%20industrial%20steel%20roof%20framework%20construction%2C%20professional%20metal%20roofing%20fabrication%20and%20assembly%2C%20modern%20commercial%20building%20roof%20structure%2C%20clean%20construction%20background&width=800&height=900&seq=gallery010&orientation=portrait'
    },
    {
      id: 11,
      title: 'Pérgolas de Metal',
      type: 'Diseño Exterior',
      image: 'https://readdy.ai/api/search-image?query=Modern%20metal%20pergola%20structure%20for%20outdoor%20spaces%2C%20custom%20fabricated%20steel%20pergola%20with%20contemporary%20design%2C%20professional%20metalwork%20for%20garden%20and%20patio%2C%20elegant%20outdoor%20metal%20architecture%2C%20clean%20landscape%20background&width=800&height=900&seq=gallery011&orientation=portrait'
    },
    {
      id: 12,
      title: 'Deck Metálico',
      type: 'Mantenimiento Industrial',
      image: 'https://static.readdy.ai/image/d57f52ecca312558916e136936375c65/f48136be4e18c34fa3353903ba428b28.jpeg'
    }
  ];

  const scroll = (direction: 'left' | 'right') => {
    if (scrollContainerRef.current) {
      const scrollAmount = 400;
      const newScrollPosition = direction === 'left' 
        ? scrollContainerRef.current.scrollLeft - scrollAmount
        : scrollContainerRef.current.scrollLeft + scrollAmount;
      
      scrollContainerRef.current.scrollTo({
        left: newScrollPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="trabajos" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-12">
          <div>
            <p className="text-sm font-semibold text-orange-600 mb-2 uppercase tracking-wide">
              {t('gallery_title')}
            </p>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
              {t('gallery_subtitle')}
            </h2>
          </div>

          {/* Navigation Buttons */}
          <div className="flex items-center space-x-3">
            <button 
              onClick={() => scroll('left')}
              className="w-12 h-12 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-full transition-colors cursor-pointer"
              aria-label="Anterior"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </button>
            <button 
              onClick={() => scroll('right')}
              className="w-12 h-12 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-full transition-colors cursor-pointer"
              aria-label="Siguiente"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>
        </div>

        {/* Projects Carousel */}
        <div className="relative">
          <div 
            ref={scrollContainerRef}
            className="flex gap-6 overflow-x-auto scrollbar-hide scroll-smooth"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {projects.map((project) => (
              <div
                key={project.id}
                className="flex-shrink-0 w-80 bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group cursor-pointer"
              >
                {/* Image */}
                <div className="relative w-full h-64 overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>

                {/* Info */}
                <div className="p-6">
                  <p className="text-xs text-gray-500 mb-3 leading-relaxed uppercase tracking-wide">
                    {project.type}
                  </p>
                  <div className="flex items-center justify-between">
                    <h3 className="text-xl font-bold text-gray-900">{project.title}</h3>
                    <i className="ri-arrow-right-up-line text-2xl text-orange-600"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
